
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-events/events",
      function () {
        return require("private-next-pages/news-and-events/events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-events/events"])
      });
    }
  